var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"report__interest-indicator-card",style:(_vm.styles)},[_c('display-title',{attrs:{"text":_vm.value}}),_c('p',{staticClass:"report__interest-indicator-label"},[_vm._v(_vm._s(_vm.label))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }